/**
 * ←/→ = previous/next slide, Home/End = first/last. Returns the index to
 * select, or null when the key does nothing here (other key, a modifier held,
 * already at that end, or no slides). No wrap-around.
 */
export function resolveSlideKeyNavigation(args: {
  key: string;
  currentIndex: number;
  count: number;
  altKey: boolean;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
}): number | null {
  const {
    key, currentIndex, count, altKey, ctrlKey, metaKey, shiftKey,
  } = args;
  if (count <= 0 || altKey || ctrlKey || metaKey || shiftKey) return null;
  const last = count - 1;
  let next: number;
  switch (key) {
    case 'ArrowLeft':
      next = currentIndex < 0 ? 0 : currentIndex - 1;
      break;
    case 'ArrowRight':
      next = currentIndex < 0 ? 0 : currentIndex + 1;
      break;
    case 'Home':
      next = 0;
      break;
    case 'End':
      next = last;
      break;
    default:
      return null;
  }
  if (next < 0 || next > last || next === currentIndex) return null;
  return next;
}
